import IInitiativeSubmissionData from 'types/IInitiativeSubmissionData'
import { IInitiativeAnswerData } from '../Interfaces'

export enum ValidationErrorResult {
  EMPTY_ANSWER = 'EMPTY_ANSWER',
  INVALID_LINK = 'INVALID_LINK',
  TOO_FEW_CHOICES = 'TOO_FEW_CHOICES',
  VALID_ANSWER = 'VALID_ANSWER'
}

export const initiativeSubmissionInitialState = {
  initiativeData: null as IInitiativeSubmissionData,
  isLoadingInitiative: false,
  isSavingInitiativeData: false,
  isSuccessDialogOpen: false,
  isIncompleteProfileDialogOpen: false,
  isSubmitting: false,
  lastAutoSaveDate: null as string,
  currentDateTime: null as string,
  validationError: false,
  answers: {
    gpaGrade: null,
    gpa: null,
    questions: {}
  } as IInitiativeAnswerData,
  validationState: {} as { [key: string]: ValidationErrorResult }
}

export type InitiativeSubmissionState = typeof initiativeSubmissionInitialState
